class Module {
  constructor() {
    this.initialized = false;
    this.items = null;
  }

  get name() {
    return 'Module';
  }

  init() {
    console.error('Module.init should be overridden!');
  }
  destroy() {
    this.initialized = false;
    
    if( this.items && this.items.length > 0 ) {
      this.items.forEach(item => item.destroy());
      this.items = null;
    }
  }
  start() {
    if( this.items && this.items.length > 0 ) {
      this.items.forEach(item => item.start());
    }
  }
  stop() {
    if( this.items && this.items.length > 0 ) {
      this.items.forEach(item => item.stop());
    }
  }

  find(el) {
    if( this.items && this.items.length > 0 ) return this.items.find(item => item.el === el);
    return null;
  }
}

export default Module;
